import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import Addon from '../../models/Addon.js';
import { toast } from 'react-toastify';

const Edit = (props) => {
  const [addon, setAddon] = useState((new Addon()).toStateJson());
  const [fetchApi] = getApi('showAddon');
  const [updateApi] = getApi('updateAddon');
  const navigate = useNavigate();
  const params = useParams();
  let addonObj = new Addon();
  
  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setAddon((new Addon(response.data.addon)).toStateJson());
    } catch(error) {
      toast.error("Something went wrong !");
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/addons");
    } catch(error) {
      addonObj.set_api_errors(error.data.data.errors);
      setAddon(addonObj.toStateJson());
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new Addon(addon)).toApiJson());
    } catch(error){
      setAddon(new Addon(addon));
    }
  }

  const onBackClick = () => {
    navigate("/addons")
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditAddonPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Addons", url: '/addons' }, { label: "Edit Addon" }]}
    className={'addon-edit-page'}
  >
    <PageContentWrapper contentHeading={"Edit Addon"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial addon={addon} setAddon={setAddon}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick}  style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>Update Addon</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
